import { Component, Input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-artunteruntergrp-list-view',
  imports: [],
  templateUrl: './artunteruntergrp.list-view.html',
  styleUrls: ['./artunteruntergrp.list-view.css'],
})
export class ArtunteruntergrpListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
